export const truncateTitle = (text, width, fontSize, shape = 'rect') => {
  // Calculate available width based on shape
  const padding = width * 0.1; // 20% padding
  const availableWidth = shape === 'rect'
    ? width - padding
    : (width / 2) * Math.sqrt(2) - padding;

  // Estimate characters that can fit based on font size
  const estimatedCharWidth = fontSize * 0.5;
  const maxChars = Math.floor(availableWidth / estimatedCharWidth);

  if (!text || text.length <= maxChars) {
    return text;
  }

  return `${text.slice(0, maxChars - 3)}...`;
};
